import { useEffect, useState, useCallback } from "react";
import { Globe, BookOpen, CheckCircle2, Activity, ShieldAlert, AlarmClock, TrendingUp, Layers } from "lucide-react";
import { StatCard } from "@/components/common/StatCard";
import { api } from "@/lib/api";

export const ProductSummary = ({ refreshKey }) => {
  const [s, setS] = useState(null);
  const load = useCallback(async () => {
    try { setS(await api.productSummary()); } catch { setS(null); }
  }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  const cards = [
    { label: "Total Planets", value: s?.total_planets ?? "—", icon: Globe, tone: "teal" },
    { label: "Total Modules", value: s?.total_modules ?? "—", icon: BookOpen, tone: "royal" },
    { label: "Modules Complete", value: s?.modules_completed ?? "—", icon: CheckCircle2, tone: "jungle" },
    { label: "In Progress", value: s?.modules_in_progress ?? "—", icon: Activity, tone: "cyan" },
    { label: "Blocked", value: s?.modules_blocked ?? "—", icon: ShieldAlert, tone: "coral" },
    { label: "Overdue", value: s?.modules_overdue ?? "—", icon: AlarmClock, tone: "orange" },
    { label: "Avg Completion", value: s ? `${s.avg_completion}%` : "—", icon: TrendingUp, tone: "purple" },
    { label: "Chapters In Production", value: s?.chapters_in_production ?? "—", icon: Layers, tone: "gold" },
  ];

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4" data-testid="product-summary">
      {cards.map((c, i) => <StatCard key={c.label} index={i} testid={`product-stat-${i}`} {...c} />)}
    </div>
  );
};
